import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "w-full flex flex-col items-center justify-center gap-4 py-16 text-center",
  "data-testid": "report-error-state"
}
const _hoisted_2 = {
  class: "w-10 h-10 text-negative",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = { class: "font-bold text-textPrimary" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-neutral50",
  "data-testid": "report-error-message"
}

import { mdiAlertCircleOutline } from '@mdi/js'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'

// Estado de erro dos relatórios gerenciais (mensal/anual): título fixo por tela +
// mensagem do service + "Tentar novamente". Mesmo padrão visual do PostStation/Index.vue.

export default /*#__PURE__*/_defineComponent({
  __name: 'ReportErrorState',
  props: {
    title: {},
    message: {}
  },
  emits: ["retry"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("path", {
        d: _unref(mdiAlertCircleOutline),
        fill: "currentColor"
      }, null, 8, _hoisted_3)
    ])),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.title), 1),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true),
    _createVNode(OutlineButton, {
      text: "Tentar novamente",
      width: "200px",
      "data-testid": "report-retry-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('retry')))
    })
  ]))
}
}

})